module.exports = {
  firebaseConfig: {
    apiKey: "AIzaSyAk1rLs8LoUVX91LLeGcr5zf8mxCAwgTyA",
    authDomain: "alueluettelo-74b9c.firebaseapp.com",
    databaseURL: "https://alueluettelo-74b9c.firebaseio.com",
    storageBucket: "alueluettelo-74b9c.appspot.com",
    messagingSenderId: "646965081106"
  },
  apiUrl: "https://api.alueluettelo.fi/api",
  logosUrl: "https://api.alueluettelo.fi/logos/",
  // apiUrl: "http://localhost:3000/api",
  // logosUrl: "http://localhost:3000/logos/",
  allowedLoginDomain: ["alueluettelo.fi"]
};



// WEBPACK FOOTER //
// ./src/config/constants.js